import { MONTHS, fmtSEK } from "../revenue/format";

export default function CashFlowSummary({ summary }) {
  const cards = [
    { label: "Opening Cash (start of year)", value: summary.opening, testId: "cf-summary-opening" },
    { label: "Expected Inflows", value: summary.inflows, testId: "cf-summary-inflows" },
    { label: "Expected Outflows", value: summary.outflows, testId: "cf-summary-outflows" },
    { label: "Net Cash Flow", value: summary.net_cash_flow, testId: "cf-summary-net" },
    { label: "Closing Cash (Dec)", value: summary.closing, strong: true, testId: "cf-summary-closing" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 mb-4" data-testid="cf-summary">
      {cards.map((c) => (
        <div
          key={c.label}
          className={`rounded-lg border p-3 ${c.strong ? "bg-[#0052CC] border-[#0052CC]" : "bg-white border-slate-200"}`}
          data-testid={c.testId}
        >
          <div className={`text-[11px] font-semibold uppercase tracking-wider ${c.strong ? "text-blue-100" : "text-slate-500"}`}>
            {c.label}
          </div>
          <div className={`text-lg font-bold mt-0.5 ${c.strong ? "text-white" : c.value < 0 ? "text-[#B91C1C]" : "text-slate-900"}`}>
            {`${fmtSEK(c.value)} kr`}
          </div>
        </div>
      ))}
      <div
        className={`rounded-lg border p-3 ${summary.lowest_closing < 0 ? "bg-[#FEF2F2] border-[#FECACA]" : "bg-white border-slate-200"}`}
        data-testid="cf-summary-lowest"
      >
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Lowest Expected Cash</div>
        <div className={`text-lg font-bold mt-0.5 ${summary.lowest_closing < 0 ? "text-[#B91C1C]" : "text-slate-900"}`}>
          {`${fmtSEK(summary.lowest_closing)} kr`}
        </div>
        <div className="text-[11px] text-slate-400">{MONTHS[summary.lowest_month - 1]} — lowest month</div>
      </div>
    </div>
  );
}
